import $ from "jquery/dist/jquery";

$(() => {
  let cm = $("#cookiesModal");
  if (cm?.attr("data-show-cookie") == "true") {
    window.NXCMS.modal(cm, true);
  }

  $(".gdpr-show-banner").click((e) => {
    e.preventDefault();
    window.NXCMS.modal(cm, true);
    return false;
  });

  $("form.gdpr_consent_form button.accept-all").click((e) => {
    e.preventDefault();
    $('#cookiesModal input[type="checkbox"]').prop("checked", true);
    $("form.gdpr_consent_form").submit();
    return false;
  });

  $("form.gdpr_consent_form button.deny-optional").click((e) => {
    e.preventDefault();
    $('#cookiesModal input[type="checkbox"]').prop("checked", false);
    $('#cookiesModal input[type="checkbox"].required').prop("checked", true);
    $("form.gdpr_consent_form").submit();
    return false;
  });

  $("form.gdpr_consent_form").submit((e) => {
    e.preventDefault();
    const f = $(e.target);
    $.ajax({
      url: f.attr("action"),
      method: f.attr("method"),
      data: f.serialize(),
    }).done((data) => {
      window.NXCMS.modal($("#cookiesModal"), false);
      if (window.NXCMS_CONSENT_MODE) {
        window.gtag?.("consent", "update", data.gtag_conent_mode_settings);
      } else {
        window.location.reload();
      }
    });
  });
});
